<div class="scope-row-header flex items-center align-middle">
  <div
    class="column level-{{ level }}"
    [ngClass]="config?.componentMainColumnClass">
    <span isEllipsisActive>{{ 'component|u' | lang }} NAME</span>
  </div>
  <div
    class="column one--column"
    [hidden]="config?.hasFractionalQuantities || !config?.scopeVersion.isScopeByScenario()">
    <span>Quantity Modifier</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.QUANTITY?.selected">
    <span>Quantity</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.START_DATE)">
    <span>Start Date</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.END_DATE)">
    <span>End Date</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.MARK_UP?.selected">
    <span>Mark-up</span>
  </div>
  <div
    class="column one--column"
    [has-setting]="ApplicationSetting.COMPONENT_SIZES__ENABLE">
    <span>{{ 'complexity' | lang }}</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected">
    <span isEllipsisActive>{{ 'scope_mark' | lang }}<br />hours</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected">
    <span isEllipsisActive>{{ 'scope_mark' | lang }}<br />price</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.AGENCY_HOURS?.selected">
    <span isEllipsisActive>{{ 'agency|p' | lang }}<br />hours</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.UNIT_PRICE?.selected">
    <span isEllipsisActive>Rate</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.scopeVersion.isScopeByScenario()">
    <span>Price Modifier</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.AGENCY_PRICE?.selected">
    <span
      isEllipsisActive
      *ngIf="!config?.scopeVersion.identity.costPlus">
      {{ 'agency' | lang }} <br />
      price
    </span>
    <span
      isEllipsisActive
      *ngIf="config?.scopeVersion.identity.costPlus">
      Cost plus <br />
      price
    </span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.showActionsColumn"></div>
</div>
